import { render, staticRenderFns } from "./BookingSummaryTable.vue?vue&type=template&id=df46c62a&"
import script from "./BookingSummaryTable.vue?vue&type=script&lang=js&"
export * from "./BookingSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports